import { render, staticRenderFns } from "./tou.md?vue&type=template&id=79d4e500&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./tou.md?vue&type=custom&index=0&blockType=frontmatter"
if (typeof block0 === 'function') block0(component)

export default component.exports